// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Vuetify from 'vuetify'
import VueParticles from 'vue-particles'
import VueAnimate from 'vue-animate-scroll'
import * as VueGoogleMaps from 'vue2-google-maps'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)
Vue.use(VueParticles)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBY0QLWLe2mTqjfwrxwCvY_wCU0wpnG1Uw',
    libraries: 'places'
  }
})
Vue.use(VueAnimate)

Vue.config.productionTip = false

/* eslint-disable no-new */
const app = new Vue({
  el: '#app',
  components: { App },
  template: `<App/>`
})



// WEBPACK FOOTER //
// ./src/main.js